import { IoIosStar } from "react-icons/io"

const VerifiedLogo = ({style}) => {
    return (
      <div style={style} className="admin__sidebar-verified">
          <IoIosStar style={{color: "#00FFE6"}}/>
        </div>
    )
  }


  export default VerifiedLogo